import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  className?: string;
}
export function CountdownTimer({
  className = ''
}: CountdownTimerProps) {
  const [time, setTime] = useState({
    hours: 23,
    minutes: 59,
    seconds: 49
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  return <div className={`flex gap-4 justify-center ${className}`} data-id="element-273">
      <div className="flex flex-col items-center" data-id="element-274">
        <div className="bg-primary text-black font-bold text-3xl md:text-4xl px-6 py-4 rounded-lg min-w-[80px] text-center" data-id="element-275">
          {String(time.hours).padStart(2, '0')}
        </div>
        <div className="text-sm text-gray-400 mt-2" data-id="element-276">horas</div>
      </div>
      <div className="flex flex-col items-center" data-id="element-277">
        <div className="bg-primary text-black font-bold text-3xl md:text-4xl px-6 py-4 rounded-lg min-w-[80px] text-center" data-id="element-278">
          {String(time.minutes).padStart(2, '0')}
        </div>
        <div className="text-sm text-gray-400 mt-2" data-id="element-279">min</div>
      </div>
      <div className="flex flex-col items-center" data-id="element-280">
        <div className="bg-primary text-black font-bold text-3xl md:text-4xl px-6 py-4 rounded-lg min-w-[80px] text-center" data-id="element-281">
          {String(time.seconds).padStart(2, '0')}
        </div>
        <div className="text-sm text-gray-400 mt-2" data-id="element-282">seg</div>
      </div>
    </div>;
}